export default "__VITE_PUBLIC_ASSET__29274f6f__"